import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { productService } from '../../services/backoffice/product.service';

import './products.scss';

export function SearchProducts(props) {
    const roleName = useSelector(state => state.userSettings.roleName);
    const countrySetting = useSelector(state => state.countrySetting);

    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 17;

    useEffect(() => {
        productService.getAll().then((result) => {
            if (result) setData(result);
        });
    }, []);

    // Filtro de búsqueda
    const filteredData = data.filter(item =>
        item.companyName?.toLowerCase().includes(search.toLowerCase()) ||
        item.providerName?.toLowerCase().includes(search.toLowerCase()) ||
        item.productName?.toLowerCase().includes(search.toLowerCase())
    );

    // Paginación
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setCurrentPage(1); // Reinicia a la primera página al buscar
    };

    const changePage = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div className="table-responsive">
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por producto, proveedor o compañía"
                    value={search}
                    onChange={handleSearch}
                />
            </div>

            <table className="wrapper_table table table-sm table-hover">
                <thead>
                    <tr>
                        <th>Intermediario/Compañía</th>
                        <th>Proveedor</th>
                        <th>Canal de venta</th>
                        <th>Producto</th>
                        <th>Valor Facial/Precio</th>
                        {roleName !== 'Administrador' && <th>Costo</th>}
                        <th>Descuento %</th>
                        <th>Precio Final</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map(item => (
                        <tr key={item.commissionProductId}>
                            <td><Link className="link_data" to={`/details-product/${item.commissionProductId}`}>{item.companyName}</Link></td>
                            <td>{item.providerName}</td>
                            <td>{item.saleChannelName}</td>
                            <td><Link className="link_data" to={`/details-product/${item.commissionProductId}`}>{item.productName}</Link></td>
                            <td>{countrySetting.currency}{Number(item.value).toLocaleString(countrySetting.cultureCode, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                            {roleName !== 'Administrador' && <td>{countrySetting.currency}{Number(item.cost).toLocaleString(countrySetting.cultureCode, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>}
                            <td>{item.commission} %</td>
                            <td>{countrySetting.currency}{Number(item.price).toLocaleString(countrySetting.cultureCode, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Controles de paginación */}
            <div className="d-flex justify-content-between align-items-center mt-3">
                <button className="btn btn-outline-secondary btn-sm" onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                    Anterior
                </button>
                <span>Página {currentPage} de {totalPages}</span>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
}
